import network from '../lib/network';

export const getDefaultActions = {
  loginAction: (context,payload) => {

    if(payload.login === 'sallysBlogPoster' && payload.password === '!Jd6gDfFKMvmdTxHf!'){
      context.commit('updateAuthentication',payload);
    }
  },
  logoutAction: (context) =>{
    context.commit('logout');
  },
  editIngredient: (context,payload) => {
    context.commit('editIngredient',payload);
  },
  deleteIngredient: (context,payload) => {
    context.commit('deleteIngredient',payload);
  },
  addIngredient: (context,payload) => {
    context.commit('setIngredient',payload);
    network.post('sallysApi.php',{
      variant:'potsdamm',
      cmd:'SallysIngredients',
      params:payload
    });
  },
  setPostToEdit: (context,payload) => {
    context.commit('setPostToEdit',payload);
  },
  changeIngredientsLoading: (context,payload) => {
    context.commit('changeIngredientsLoading',payload);
  },
  changePostsLoading: (context,payload) => {
    context.commit('changePostsLoading',payload);
  },
  fetchIngredients: (context) => {
    network.post('sallysApi.php',{'variant':'gettysburg','cmd':'SallysIngredients'}).then(response => {
      if(response.success){
        context.commit('fetchIngredients',response.data);
        context.commit('changeIngredientsLoading',false);
      }
    }).catch(error => {
      console.log(error);
    });
  },
  resetPostsLoading:(context) => {
    context.commit('resetLoadingStatus');
  },
  fetchPosts: (context) => {
    network.post('sallysApi.php',{'variant':'gettysburg','cmd':'SallysBlog?filter[bg]=1'}).then(response => {
      if(response.success){
        context.commit('fetchPosts',response.data);
      }
    }).catch(error => {
      console.log(error);
    });
  },
  fetchCategories: (context) => {
    network.post('sallysApi.php',{'variant':'gettysburg','cmd':'categories?filter[blog]=1'}).then(response => {
      if(response.success){
        context.commit('fetchCategories',response.data);
      }
    }).catch(error => {
      console.log(error);
    });
  },
  fetchPostToEdit: (context,payload) => {
    network.post('sallysApi.php',{'variant':'gettysburg','cmd':'SallysBlog?filter[id]='+payload}).then(response => {
      if(response.success){
        context.commit('fetchPostToEdit',response.data);
      }
    }).catch(error => {
      console.log(error);
    });
  },
  savePostData: (context,payload) => {
    payload.content.content_container = rebuildContainerIndex(payload.content.content_container,true);
    payload.content.recipe_container = rebuildContainerIndex(payload.content.recipe_container);
    let data = undefined;
    payload.content.publishing_date_from = payload.content.publishing_date_from_date+' '+payload.content.publishing_date_from_time
    payload.content.created_at = payload.content.publishing_date_from;
    let blogModel = reformatToBlogModel( payload.content);
    if(payload.isEditing){
      blogModel.attribute.updated_at = new Date().toISOString().slice(0, 19).replace('T', ' ');
    }
    data = {'variant':'potsdamm','cmd':'SallysBlog','params':blogModel};
    network.post('sallysApi.php',data).then(response => {
      if(response.success){
        context.commit('togglePostIsSaved');
      }
    }).catch(error => {
      console.log(error);
    });
  },
  resetIsPostSaved:(context) => {
    context.commit('postIsSaved',false);
  },
  checkTime:({commit},payload) => {
    commit('checkAllowedTime',payload);
  },
  ask: ({ commit }, { title, body }) => {
    return new Promise((resolve, reject) => {
      commit('activateDialog', {
        active: true,
        title,
        body,
        resolve,
        reject
      })
    })
  },
  fetchStats: (context) => {
    let data = {'variant':'potsdamm','cmd':'SallysBlog','params':{charts:true}};
    network.post('sallysApi.php',data).then(response => {
      if(response.success){
        context.commit('updateCharts',response.data);
      }
    }).catch(error => {
      console.log(error);
    });
  },
  deletePost:(context,payload) => {
    console.log(payload);
    let data = {'variant':'potsdamm','cmd':'SallysBlog','params':{'delete':true,'delaware':payload}};
    network.post('sallysApi.php',data);
    context.commit('dontDoanything');
  }
}


function rebuildContainerIndex(container,kindof = false){
  container.forEach((value,index) => {
    container[index].record_id = index;
    if(kindof){
      container[index].position = index;
      if(container[index].content_type == '6'){
        container[index].content_element_text = container[index].content_element_text.replace(/(<p[^>]+?>|<p>|<\/p>)/img, '')
      }
    }
  });
  return container;
}

function reformatToBlogModel(postItem){
  let blogModel = {
    'title': postItem.blog_title,
    'authorId':'50',
    'active':postItem.is_active,
    'shortDescription':postItem.blog_title,
    'description':postItem.opener_text,
    'displayDate':postItem.publishing_date_from_date+' '+postItem.publishing_date_from_time,
    'categoryId':postItem.new_category_id,
    'template':'',
    'metaKeywords': postItem.tags,
    'metaDescription':postItem.opener_text.trunc(340),
    'metaTitle': postItem.dreisc_seo_url !== ''? postItem.dreisc_seo_url : postItem.blog_title,
    'attribute': reformatToBlogAttributesModel(postItem)
  }
  if(postItem.id !== ''){
    blogModel.id = postItem.id;
  }
  if(postItem.recipeTitleAsMeta){
    blogModel.meta_title = postItem.recipe_title;
  }
  return blogModel;
}

function reformatToBlogAttributesModel(postItem){
  let keys = {
    'oldid': postItem.oldid,
    'createdAt':postItem.publishing_date_from_date+' '+postItem.publishing_date_from_time,
    'updatedAt':new Date().toLocaleString().slice(0, 19).replace('T', ' '),
    'title':postItem.blog_title,
    'type':postItem.type,
    'publishingDateFrom':postItem.publishing_date_from_date+' '+postItem.publishing_date_from_time,
    'publishingDateTo':'',
    'tags': postItem.tags,
    'isActive':postItem.is_active,
    'isFeatured':postItem.is_featured,
    'daysMarkedAsNew':postItem.days_marked_as_new,
    'mainCategory': '',
    'oldcategories': '',
    'countDiameterPieces':postItem.count_diameter_pieces,
    'recipeType':postItem.recipe_type == '' ? 'Durchmesser' : postItem.recipe_type,
    'formFactor':postItem.form_factor == '' ? 'rund' : postItem.form_factor,
    'formHeight':postItem.form_height,
    'formLength':postItem.form_length,
    'formWidth':postItem.form_width,
    'attributeZubereitungszeit':postItem.attribute_zubereitungszeit,
    'attributeWartezeit':postItem.attribute_wartezeit,
    'attributeBackzeit':postItem.attribute_backzeit,
    'attributeKuehlzeit':postItem.attribute_kuehlzeit,
    'attributeGefrierdauer':postItem.attribute_gefrierdauer,
    'attributeKochzeit':postItem.attribute_kochzeit,
    'attributeSchwierigkeitsgrad':postItem.attribute_schwierigkeitsgrad,
    'openerMediaType':postItem.opener_media_type,
    'openerImages':postItem.opener_images.length < 1 ? '' : postItem.opener_images,
    'openerVideos':postItem.opener_videos,
    'recipeContainer':postItem.recipe_container.length < 1 ? '' : postItem.recipe_container,
    'recipeTitle':postItem.recipe_title,
    'openerText':postItem.opener_text,
    'contentContainer':postItem.content_container.length < 1 ? '' : postItem.content_container,
    'attributeDauer':postItem.attribute_dauer,
    'attributeGrad':postItem.attribute_grad,
    'attributeHeizart':postItem.attribute_heizart,
    'dreiscSeoUrl': postItem.dreisc_seo_url
  };
  if(postItem.extraTitle){
    keys.title = postItem.recipe_title;
  }
  return keys;
}
